module.exports = __webpack_public_path__ + "static/media/last-sold-cars-mini-blurred.010fa8ae.png";